import api from '../api/client'

const usuariosService = {
  // Listar usuários por organizador
  getByOrganizador: async (organizadorId, search = '', mostrarInativos = false) => {
    const params = new URLSearchParams()
    if (search) params.append('search', search)
    if (mostrarInativos) params.append('mostrar_inativos', 'true')
    const response = await api.get(`/organizadores/${organizadorId}/usuarios?${params}`)
    return response.data
  },

  // Criar usuário
  create: async (organizadorId, userData) => {
    const response = await api.post(`/organizadores/${organizadorId}/usuarios`, userData)
    return response.data
  },

  // Atualizar usuário
  update: async (organizadorId, userId, userData) => {
    const response = await api.put(`/organizadores/${organizadorId}/usuarios/${userId}`, userData)
    return response.data
  },

  // Inativar / reativar usuário
  toggleStatus: async (organizadorId, userId) => {
    const response = await api.patch(`/organizadores/${organizadorId}/usuarios/${userId}/status`)
    return response.data
  },

  // Excluir usuário (mantido por compatibilidade)
  delete: async (organizadorId, userId) => {
    const response = await api.delete(`/organizadores/${organizadorId}/usuarios/${userId}`)
    return response.data
  },

  // Obter usuário por ID
  getById: async (organizadorId, userId) => {
    const response = await api.get(`/organizadores/${organizadorId}/usuarios/${userId}`)
    return response.data
  },

  // Log de verificação (2FA): quem tentou, código, IP, dispositivo, data/hora
  getLog2FA: async (organizadorId, limit = 200) => {
    const response = await api.get(`/organizadores/${organizadorId}/usuarios/2fa-log`, { params: { limit } })
    return response.data
  }
}

export default usuariosService
